const getFirstDefined = (source, keys, fallback = undefined) => {
  if (!source || typeof source !== 'object') return fallback

  for (const key of keys) {
    if (source[key] !== undefined && source[key] !== null && source[key] !== '') {
      return source[key]
    }
  }

  return fallback
}

const toStringSafe = (value, fallback = '') => {
  if (value === undefined || value === null) return fallback
  return String(value).trim()
}

const toNumberSafe = (value, fallback = 0) => {
  if (typeof value === 'number' && Number.isFinite(value)) return value
  if (value === undefined || value === null || value === '') return fallback

  const strValue = String(value).trim()
  let normalized = strValue

  if (strValue.includes(',')) {
    normalized = strValue.replace(/\./g, '').replace(',', '.')
  }

  const parsed = Number(normalized)
  return Number.isFinite(parsed) ? parsed : fallback
}

const getEtiquetasImp = (item) => toNumberSafe(getFirstDefined(item, ['TTL_ETIQUETAS_IMP', 'ttl_etiquetas_imp'], 0), 0)

const getEtiquetasSem = (item) => toNumberSafe(getFirstDefined(item, ['TTL_ETIQUETAS_SEM', 'ttl_etiquetas_sem'], 0), 0)

const getVolumes = (item) => {
  const explicitVolume = getFirstDefined(item, ['VOLUMES', 'Volume', 'volume'], undefined)
  if (explicitVolume !== undefined) {
    return toNumberSafe(explicitVolume, 0)
  }

  return getEtiquetasImp(item) + getEtiquetasSem(item)
}

const parseDateSafe = (value) => {
  if (!value) return null
  const parsed = new Date(value)
  return Number.isNaN(parsed.getTime()) ? null : parsed
}

const normalizeNotaStatus = (item) => {
  const etiquetasImp = getEtiquetasImp(item)
  const etiquetasSem = getEtiquetasSem(item)

  if (etiquetasSem > 0) return 0
  if (etiquetasImp > 0) return 1

  const rawStatus = getFirstDefined(item, ['STATUS', 'status', 'Status', 'Impresso'], 0)
  const parsedStatus = Number(rawStatus)

  if (Number.isFinite(parsedStatus)) {
    if (parsedStatus === 1) return 1
    if (parsedStatus === 0) return 0
    return 0
  }

  const asString = toStringSafe(rawStatus).toUpperCase()
  if (!asString) return 0

  return ['1', 'IMPRESSA', 'IMPRESSO', 'SIM', 'S', 'TRUE'].includes(asString) ? 1 : 0
}

const buildNota = (item, romaneioData) => {
  const remetente = toStringSafe(getFirstDefined(item, ['REMETENTE', 'DsRemetente', 'dsremetente', 'RMTE'], 'REMETENTE NíO INFORMADO'))
  const destinatario = toStringSafe(getFirstDefined(item, ['DESTINATARIO', 'NMDESTINATARIO', 'destinatario', 'CLIENTE'], 'DESTINATÁRIO NíO INFORMADO'))
  const destino = toStringSafe(getFirstDefined(item, ['CIDADE', 'cidade', 'DESTINO', 'destino', 'NMCIDADE', 'nmcidade', 'Praca', 'PRACA'], 'CIDADE NíO INFORMADA'))
  const uf = toStringSafe(getFirstDefined(item, ['UF', 'uf', 'SGESTADO', 'sgestado'], ''))
  const etiquetasImp = getEtiquetasImp(item)
  const etiquetasSem = getEtiquetasSem(item)
  const volumes = getVolumes(item)
  const peso = toNumberSafe(getFirstDefined(item, ['PESO', 'Peso', 'peso'], 0), 0)
  const m3 = toNumberSafe(getFirstDefined(item, ['M3', 'm3'], 0), 0)
  const nota = toStringSafe(getFirstDefined(item, ['NOTA', 'Nota', 'nota', 'NrNota'], 'SEM NOTA'))
  const serie = toStringSafe(getFirstDefined(item, ['SERIE', 'Serie', 'serie', 'NrSerie'], '1'))
  const pedido = toStringSafe(getFirstDefined(item, ['PEDIDO', 'Pedido', 'pedido', 'nrpedido'], '0'))
  const praca = toStringSafe(getFirstDefined(item, ['PRACA', 'Praca', 'praca'], 'N/D'))
  const cd = toStringSafe(getFirstDefined(item, ['CD', 'cd', 'C.D'], 'N/D'))
  const rota = toStringSafe(getFirstDefined(item, ['ROTA', 'Rota', 'rota', 'CdRota', 'cdrota'], 'N/D'))
  const cep = toStringSafe(getFirstDefined(item, ['CEPENTREGA', 'cepentrega', 'CEP'], ''))

  return {
    chave: toStringSafe(getFirstDefined(item, ['CHAVE', 'chave', 'codigo'], `${nota}-${serie}`)),
    codigo: toStringSafe(getFirstDefined(item, ['codigo', 'CODIGO'], '')),
    cnpjrmte: toStringSafe(getFirstDefined(item, ['CNPJ', 'cdremetente', 'CdInscricao'], '')),
    cdremetente: toStringSafe(getFirstDefined(item, ['CNPJ', 'cdremetente', 'CdInscricao'], '')),
    remetente,
    dsremetente: remetente,
    DsRemetente: remetente,
    nota,
    serie,
    pedido,
    volumes,
    etiquetasImp,
    etiquetasSem,
    peso,
    m3,
    destinatario,
    endereco: toStringSafe(getFirstDefined(item, ['ENDERECO', 'endereco'], '')),
    numero: toStringSafe(getFirstDefined(item, ['NUMERO', 'numero'], '')),
    cepentrega: cep,
    cep,
    destino,
    cidade: destino,
    praca,
    cd,
    rota,
    uf,
    status: normalizeNotaStatus(item),
    primeira_etiqueta: getFirstDefined(item, ['PRIMEIRA_ETIQUETA', 'primeira_etiqueta', 'DTIMPRESSAO', 'DATA_ETIQUETA'], null),
    ultima_etiqueta: getFirstDefined(item, ['ULTIMA_ETIQUETA', 'ultima_etiqueta', 'DTIMPRESSAO', 'DATA', 'DATA_ETIQUETA'], null),
    dtimpressao: getFirstDefined(item, ['DTIMPRESSAO', 'dtimpressao'], null),
    status_coleta: toStringSafe(getFirstDefined(item, ['STATUS_COLETA', 'status_coleta'], '')),
    carro: romaneioData.placa,
    romaneio: romaneioData.romaneio,
    empresa: romaneioData.empresa
  }
}

const buildColetas = (items, romaneioData) => {
  const groups = new Map()

  items.forEach((item, index) => {
    const cnpj = toStringSafe(getFirstDefined(item, ['CNPJ', 'cdremetente', 'CdInscricao'], `SEM_CNPJ_${index}`))
    const remetente = toStringSafe(getFirstDefined(item, ['REMETENTE', 'DsRemetente', 'dsremetente', 'RMTE'], 'REMETENTE NíO INFORMADO'))
    const coletaNumero = toStringSafe(getFirstDefined(item, ['COLETA', 'NrColeta', 'nrcoleta'], `${index + 1}`))
    const key = `${cnpj}|${coletaNumero}`

    if (!groups.has(key)) {
      groups.set(key, {
        NrColeta: coletaNumero,
        DsEntidade: remetente,
        DsRemetente: remetente,
        dsremetente: remetente,
        CdInscricao: cnpj,
        hrlimite: getFirstDefined(item, ['HRLIMITE', 'hrlimite'], ''),
        DsObservacao: toStringSafe(getFirstDefined(item, ['OBSERVACAO', 'DsObservacao', 'observacao'], '')),
        totals: {
          notas: 0,
          vols: 0,
          peso: 0,
          m3: 0,
          falta: 0
        },
        notas: []
      })
    }

    const nota = buildNota(item, romaneioData)
    const coleta = groups.get(key)

    coleta.notas.push(nota)
    coleta.totals.notas += 1
    coleta.totals.vols += nota.volumes
    coleta.totals.peso += nota.peso
    coleta.totals.m3 += nota.m3
    coleta.totals.falta += nota.status === 0 ? 1 : 0
  })

  return Array.from(groups.values()).sort((a, b) => {
    const coletaCompare = toStringSafe(a.NrColeta).localeCompare(toStringSafe(b.NrColeta))
    if (coletaCompare !== 0) return coletaCompare
    return toStringSafe(a.DsEntidade).localeCompare(toStringSafe(b.DsEntidade))
  })
}

const buildTotals = (coletas) => {
  const totals = {
    notas: 0,
    vols: 0,
    peso: 0,
    m3: 0,
    falta: 0,
    notasImpressas: 0,
    notasNaoImpressas: 0,
    etiquetasImpressas: 0,
    etiquetasNaoImpressas: 0,
    primeiraEtiqueta: null,
    ultimaEtiqueta: null
  }

  coletas.forEach((coleta) => {
    totals.notas += coleta.totals.notas
    totals.vols += coleta.totals.vols
    totals.peso += coleta.totals.peso
    totals.m3 += coleta.totals.m3
    totals.falta += coleta.totals.falta

    coleta.notas.forEach((nota) => {
      if (nota.status === 0) {
        totals.notasNaoImpressas += 1
        totals.etiquetasNaoImpressas += nota.etiquetasSem || nota.volumes
      } else if (nota.status === 1) {
        totals.notasImpressas += 1
        totals.etiquetasImpressas += nota.etiquetasImp || nota.volumes
      }

      const primeira = parseDateSafe(nota.primeira_etiqueta)
      const ultima = parseDateSafe(nota.ultima_etiqueta)

      if (primeira && (!totals.primeiraEtiqueta || primeira < totals.primeiraEtiqueta)) {
        totals.primeiraEtiqueta = primeira
      }

      if (ultima && (!totals.ultimaEtiqueta || ultima > totals.ultimaEtiqueta)) {
        totals.ultimaEtiqueta = ultima
      }
    })
  })

  return totals
}

const buildVehicleData = (items, record = {}) => {
  const sample = items[0] || {}
  const capacidadeIdeal = toNumberSafe(getFirstDefined(sample, ['VL_CAPAC_IDEAL', 'VlCapacIdeal', 'capacidadeIdeal'], 0), 0)
  const altura = toNumberSafe(getFirstDefined(sample, ['QT_ALTURA', 'QtAltura', 'altura'], 0), 0)
  const largura = toNumberSafe(getFirstDefined(sample, ['QT_LARGURA', 'QtLargura', 'largura'], 0), 0)
  const comprimento = toNumberSafe(getFirstDefined(sample, ['QT_COMPRIMENTO', 'QtComprimento', 'comprimento'], 0), 0)
  const m3Calculado = altura && largura && comprimento ? altura * largura * comprimento : 0

  const pesoVeiculo = toNumberSafe(getFirstDefined(record, ['pesoVeiculo', 'PESO_VEICULO', 'peso_veiculo'], 0), 0)
  const m3Veiculo = toNumberSafe(getFirstDefined(record, ['m3Veiculo', 'M3_VEICULO', 'm3_veiculo'], 0), 0)

  return {
    capacidadeIdeal: capacidadeIdeal > 0 ? capacidadeIdeal : 0,
    altura,
    largura,
    comprimento,
    m3Calculado,
    pesoVeiculo,
    m3Veiculo
  }
}

const buildProductividade = (coletas) => {
  return coletas.map((coleta) => {
    let primeiraEtiqueta = null
    let ultimaEtiqueta = null

    coleta.notas.forEach((nota) => {
      const primeira = parseDateSafe(nota.primeira_etiqueta)
      const ultima = parseDateSafe(nota.ultima_etiqueta)

      if (primeira && (!primeiraEtiqueta || primeira < primeiraEtiqueta)) {
        primeiraEtiqueta = primeira
      }

      if (ultima && (!ultimaEtiqueta || ultima > ultimaEtiqueta)) {
        ultimaEtiqueta = ultima
      }
    })

    return {
      key: coleta.CdInscricao || coleta.NrColeta,
      cliente: coleta.DsEntidade || 'Cliente não identificado',
      primeiraEtiqueta,
      ultimaEtiqueta
    }
  })
}

export const buildOnboardPreviewData = (record, empresaAtual = '') => {
  const items = Array.isArray(record?.items) ? record.items : []
  const empresa = toStringSafe(record?.empresa || empresaAtual || getFirstDefined(items[0], ['EMPRESA', 'Filial', 'FILIAL'], ''), '')
  const placa = toStringSafe(record?.veiculo || record?.CARRO || getFirstDefined(items[0], ['CARRO', 'NrPlaca'], ''), '')
  const romaneio = toStringSafe(record?.romaneio || record?.ROMANEIO || getFirstDefined(items[0], ['ROMANEIO', 'CdRomaneio'], ''), '')
  const origemVinculo = toStringSafe(record?.origemVinculo || record?.ORIGEM_VINCULO || 'CARRO', 'CARRO').toUpperCase()

  const romaneioData = {
    empresa,
    placa,
    romaneio,
    origemVinculo
  }

  const alteracoesList = []
  const reimpressoesList = []

  items.forEach((item) => {
    if (!item.alteracoes) return

    try {
      const parsed = typeof item.alteracoes === 'string' ? JSON.parse(item.alteracoes) : item.alteracoes

      if (!Array.isArray(parsed)) return

      const remetente = toStringSafe(getFirstDefined(item, ['REMETENTE', 'DsRemetente', 'dsremetente', 'RMTE'], 'REMETENTE NíO INFORMADO'))
      const nota = toStringSafe(getFirstDefined(item, ['NOTA', 'Nota', 'nota', 'NrNota'], 'SEM NOTA'))

      parsed.forEach((alteracao) => {
        const entry = {
          ...alteracao,
          remetente,
          nota
        }

        const acao = toStringSafe(alteracao?.acao || alteracao?.ACAO).toUpperCase()
        if (acao === 'REIMPRESSAO' || acao === 'REimpressão') {
          reimpressoesList.push(entry)
        } else {
          alteracoesList.push(entry)
        }
      })
    } catch (error) {
      console.warn('Erro ao interpretar alterações para o preview.', error)
    }
  })

  const coletas = buildColetas(items, romaneioData)
  const totals = buildTotals(coletas)
  const vehicleData = buildVehicleData(items, record)
  const clienteSelecionado = coletas[0] || null
  const produtividade = buildProductividade(coletas)

  return {
    meta: {
      veiculo: placa,
      romaneio,
      empresa,
      origemVinculo,
      totalRegistrosOriginais: items.length
    },
    romaneioData,
    vehicleData,
    totals,
    coletas,
    clienteSelecionadoInicial: clienteSelecionado,
    numeroColetaInicial: clienteSelecionado?.NrColeta || null,
    alteracoes: alteracoesList,
    reimpressoes: reimpressoesList,
    produtividade
  }
}

export default buildOnboardPreviewData
